export enum RightsNotificationTypeEnum {
  DATA_BASED_NOTIFICATION = 'DATA_BASED_NOTIFICATION' ,
  FUNCTION_BASED_NOTIFICATION = 'FUNCTION_BASED_NOTIFICATION',
  USER_RIGHTS_NOTIFICATION = 'USER_RIGHTS_NOTIFICATION',
  USER_RIGHTS_CHANGED_BY_USER_NOTIFICATION = 'USER_RIGHTS_CHANGED_BY_USER_NOTIFICATION'
}
